module.exports = __webpack_public_path__ + "static/media/hungry-cat.ec7497c0.jpg";